import { parseAuthError } from "../../../shared/helpers/api-helper-b";
import jobStatus from "../../../shared/variables/job-status";

import {
  FORGOT_LOGIN,
  FORGOT_LOGIN_SUCCESS,
  FORGOT_LOGIN_FAILED,
} from "../actions";

const initialState = {
  status: jobStatus.NOT_STARTED,
  successMessage: undefined,
  error: undefined,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FORGOT_LOGIN:
      return {
        ...state,
        status: jobStatus.PROCESSING,
      };
    case FORGOT_LOGIN_SUCCESS: {
      return {
        ...state,
        status: jobStatus.SUCCESS,
        successMessage: payload.success,
      };
    }
    case FORGOT_LOGIN_FAILED: {
      return {
        ...state,
        status: jobStatus.FAILED,
        error: parseAuthError(payload?.errors),
      };
    }
    default:
      return state;
  }
};
